var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"height":"300px","width":"100%","position":"relative","text-align":"center"}},[_c('div',[_vm._v(_vm._s(_vm.message))]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.langConv('There is no data that matches your selection(s)'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }